import { Component, OnInit } from '@angular/core';
import { Globals } from "../../_models/globals";
import { User } from "../../_models/user";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-shift-delivery-create',
  templateUrl: './shift-delivery-create.component.html',
  styleUrls: ['./shift-delivery-create.component.scss'],
})
export class ShiftDeliveryCreateComponent implements OnInit {

  carrierName: string;
  carrierNameError: string;
  accessKey: string;
  accessKeyError: string;
  secretKey: string;
  secretKeyError: string;

  constructor(private alertService: AlertService, private g: Globals, private user: User, private http: HttpClient, private router: Router, private route: ActivatedRoute) {
  }



  carrierNameBlur() {
    this.carrierNameError = "";
    if (!this.carrierName) {
      this.carrierNameError = 'Please Enter Carrier Name';
    }
  }

  accessKeyBlur() {
    this.accessKeyError = "";
    if (!this.accessKey) {
      this.accessKeyError = 'Please Enter Access Key';
    }
  }

  secretKeyBlur() {
    this.secretKeyError = "";
    if (!this.secretKey) {
      this.secretKeyError = 'Please Enter Secret Key';
    }
  }

  ngOnInit() { }

  verify() {

    this.g.loaderDisplay = "display";
    this.carrierNameError = "";
    this.accessKeyError = "";
    this.secretKeyError = "";

    if (!this.carrierName) {
      this.carrierNameError = 'Please Enter Carrier Name';
    }
    if (!this.accessKey) {
      this.accessKeyError = 'Please Enter Access Key';
    }
    if (!this.secretKey) {
      this.secretKeyError = 'Please Enter Secret Key';
    }
    if (this.carrierNameError != "" || this.accessKeyError != "" || this.secretKeyError != "") {
      this.g.loaderDisplay = "";
      return false;
    }

    // api body

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/verifyAndSaveCarrierCredentials', {
      "accessKey": this.accessKey,
      "accountOwnerId": this.user.accountOwnerId,
      "carrierCode": "SD",
      "connectionName": this.carrierName,
      "organizationId": 1,
      "secretkey": this.secretKey
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Shift Delivery', 'Create Successfully');
          this.router.navigate(['/admin/customerCarriers']);
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
        })
  }



}
